import React from "react"
import { useSurveyReportExportContext } from "contexts/SurveyReportExportContext"
import LocationAnswerFiltersQuestionSelect from "./LocationAnswerFiltersQuestionSelect"
import LocationAnswerFiltersLocationDetails from "./LocationAnswerFiltersLocationDetails"

const NewSurveyReportExportFormLocationAnswerFilters = () => {
  const { locationAnswerFilters } = useSurveyReportExportContext()

  const locationAnswerFilter = locationAnswerFilters[0] ?? {}
  const { questionUuid } = locationAnswerFilter

  return (
    <div className="w-full">
      <LocationAnswerFiltersQuestionSelect />
      {
        questionUuid && (
          <LocationAnswerFiltersLocationDetails />
        )
      }
    </div>
  )
}

export default NewSurveyReportExportFormLocationAnswerFilters
